<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">

      <h1>
        <p class="text-center font-weight-bold">Cadastrar administrador unidade </p>
        <!-- {{recepcionista}} -->
      </h1>

      <v-form v-model="valid" ref="form" class="mx-4">
        <v-text-field label="Nome Completo" v-model="nome" :rules="nameCompleto" required></v-text-field>

        <v-text-field label="Username" v-model="username" :rules="nameRules" required></v-text-field>
        <v-text-field v-model="senha" autocomplete="new-password" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Senha" counter @click:append="show1 = !show1"></v-text-field>

        <v-text-field v-model="senhaRepetida" :append-icon="show2 ? 'visibility' : 'visibility_off'" :rules="[this.senha == this.senhaRepetida || 'As Senha devem ser iguais']" :type="show2 ? 'text' : 'password'" label="Confirmar senha" counter @click:append="show2 = !show2"></v-text-field>

        <v-form>
          <v-text-field v-model="nomeUnidade" disabled readonly :rules="nomeRules" name="input-10-1" label=" Unidade" counter></v-text-field>
        </v-form>
        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concordar para cadastrar!']" required></v-checkbox>

        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Username já existente !!
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso so editar nome !!
        </v-alert>

      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark @click="editarUnidade" :class="{ red: !valid, green: valid }">Salvar</v-btn>
        <v-btn text @click="" to='/listaUnidade'>
          <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
      </v-card-actions>
      <!-- <v-layout  row wrap >
   <v-flex x12>
     <v-flex xs10 offset-xs1>
          lista de servicos
     </v-flex>
    </v-flex>
</v-layout>  -->
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'
// import EventBus from '../../../main';

export default {
  name: 'editarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: true,
      senha: '',
      show1: false,
      nome: '',
      username: '',
      show2: false,
      senhaRepetida: '',
      idAdministradorEscolhido: '',
      sucessoEditar: false,
      listaFuncionarios: [],
      idUnidade: null,
      isEditing: true,
      nomeUnidade: '',
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 7 caracteres'
      ],
      rules: {
        min: v => v.length >= 8 || 'Minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'Senha deve ter 6 ou mais caracteres'
      ],
      senhasIgualsRules: [
        (v) => v && v.length > 5 || 'Senha deve ter 6 ou mais caracteres'
      ],
      nameRules: [
        (v) => !!v || 'Nome obrigatório',
        (v) => v && v.length > 7 || 'Username deve ter mais de 7 caracteres '
      ],
      nameCompleto: [
        (v) => !!v || 'Nome completo obrigatório',
        (v) => v && v.length > 7 || 'deve ter mais de 7 caracteres '
      ]
    }
  },
  mounted () {
    console.log('mounted...')

    if (!this.$route.params.item) {
      this.$router.push('/listaUnidade')
      return
    }
    this.user = this.$store.getters.usuario
    this.nomeUnidade = this.$route.params.item.nomeUnidade
    this.idUnidade = this.$route.params.item.idUnidade,
    this.erroEditar = false,
    this.sucessoEditar = false
    this.retornarAdministradores()
  },
  methods: {

    retornarAdministradores () {
      console.log('em retornar Administradores...')
      administradorService.administrador
        .retornarAdministradores(this.user.idEmpresa)
        .then(rsp => {
          console.log('rsp oi:')
          this.listaFuncionarios = rsp.data.listaAdministradores
          console.log(rsp.data.listaFuncionarios)
          console.log(this.listaFuncionarios)
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    editarUnidade () {
      console.log('em alterarNomeUnidade')

      if (this.$refs.form.validate()) {
        this.erroEditar = false
        this.sucessoEditar = false
        administradorService.administrador
          .cadastrarAdministrador(this.senha, this.username, this.idUnidade, this.nome)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'usernameExistente') {
              this.erroEditar = true
            }
            if (rsp.data == 'true') {
              this.idUnidade = null,
              this.sucessoEditar = true
              setTimeout(() => this.$router.push({
                path: '/listaUnidade'
              }), 2000)
              // this.clear();
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    clear () {
      console.log('limpar')
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
